export default __webpack_public_path__ + "static/media/11-song.4cbd8d8d.png";